package ca.derekellis.reroute.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String
import kotlin.Unit

public class StopsQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getById(id: String, mapper: (
    id: String,
    code: String,
    name: String,
    desc: String?,
    lat: Double,
    lon: Double,
    zone_id: Long?,
    url: String?,
    location_type: Long,
  ) -> T): Query<T> = GetByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getDouble(4)!!,
      cursor.getDouble(5)!!,
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getLong(8)!!
    )
  }

  public fun getById(id: String): Query<Stops> = getById(id) { id_, code, name, desc, lat, lon,
      zone_id, url, location_type ->
    Stops(
      id_,
      code,
      name,
      desc,
      lat,
      lon,
      zone_id,
      url,
      location_type
    )
  }

  public fun <T : Any> getByCode(code: String, mapper: (
    id: String,
    code: String,
    name: String,
    desc: String?,
    lat: Double,
    lon: Double,
    zone_id: Long?,
    url: String?,
    location_type: Long,
  ) -> T): Query<T> = GetByCodeQuery(code) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getDouble(4)!!,
      cursor.getDouble(5)!!,
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getLong(8)!!
    )
  }

  public fun getByCode(code: String): Query<Stops> = getByCode(code) { id, code_, name, desc, lat,
      lon, zone_id, url, location_type ->
    Stops(
      id,
      code_,
      name,
      desc,
      lat,
      lon,
      zone_id,
      url,
      location_type
    )
  }

  public fun <T : Any> getAll(mapper: (
    id: String,
    code: String,
    name: String,
    desc: String?,
    lat: Double,
    lon: Double,
    zone_id: Long?,
    url: String?,
    location_type: Long,
  ) -> T): Query<T> = Query(-2084575348, arrayOf("stops"), driver, "Stops.sq", "getAll",
      "SELECT * FROM stops") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getDouble(4)!!,
      cursor.getDouble(5)!!,
      cursor.getLong(6),
      cursor.getString(7),
      cursor.getLong(8)!!
    )
  }

  public fun getAll(): Query<Stops> = getAll { id, code, name, desc, lat, lon, zone_id, url,
      location_type ->
    Stops(
      id,
      code,
      name,
      desc,
      lat,
      lon,
      zone_id,
      url,
      location_type
    )
  }

  public suspend fun insert(
    id: String,
    code: String,
    name: String,
    desc: String?,
    lat: Double,
    lon: Double,
    zone_id: Long?,
    url: String?,
    location_type: Long,
  ): Unit {
    driver.execute(-2019000358, """INSERT INTO stops VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)""", 9) {
          bindString(0, id)
          bindString(1, code)
          bindString(2, name)
          bindString(3, desc)
          bindDouble(4, lat)
          bindDouble(5, lon)
          bindLong(6, zone_id)
          bindString(7, url)
          bindLong(8, location_type)
        }.await()
    notifyQueries(-2019000358) { emit ->
      emit("stop_search")
      emit("stops")
    }
  }

  private inner class GetByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    public override fun addListener(listener: Query.Listener): Unit {
      driver.addListener(listener, arrayOf("stops"))
    }

    public override fun removeListener(listener: Query.Listener): Unit {
      driver.removeListener(listener, arrayOf("stops"))
    }

    public override fun <R> execute(mapper: (SqlCursor) -> R): QueryResult<R> =
        driver.executeQuery(-197285049, """SELECT * FROM stops WHERE id = ?""", mapper, 1) {
      bindString(0, id)
    }

    public override fun toString(): String = "Stops.sq:getById"
  }

  private inner class GetByCodeQuery<out T : Any>(
    public val code: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    public override fun addListener(listener: Query.Listener): Unit {
      driver.addListener(listener, arrayOf("stops"))
    }

    public override fun removeListener(listener: Query.Listener): Unit {
      driver.removeListener(listener, arrayOf("stops"))
    }

    public override fun <R> execute(mapper: (SqlCursor) -> R): QueryResult<R> =
        driver.executeQuery(-612536039, """SELECT * FROM stops WHERE code = ?""", mapper, 1) {
      bindString(0, code)
    }

    public override fun toString(): String = "Stops.sq:getByCode"
  }
}
